// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0b80083a","455":"d2d542c4","644":"7e858e24"}[chunkId] + ".chunk.js";
};